import { POST, FB_POST_TYPES } from '@/lib/posts/postTypes';

import { videoViewsCompleteMVConfig } from '@/lib/analytics/kpis/facebook/mediaViewer/videoViewsComplete';
import { videoViews3SecMVConfig } from '@/lib/analytics/kpis/facebook/mediaViewer/videoViews3Sec';
import { videoViews10SecMVConfig } from '@/lib/analytics/kpis/facebook/mediaViewer/videoViews10Sec';
import { videoViewsTotalTimeMVConfig } from '@/lib/analytics/kpis/facebook/mediaViewer/videoViewsTotalTime';
import { videoViewsAvgTimeWatchedMVConfig } from '@/lib/analytics/kpis/facebook/mediaViewer/videoViewsAvgTimeWatched';
import { reactionsMVConfig } from '@/lib/analytics/kpis/facebook/mediaViewer/reactions';
import { commentsMVConfig } from '@/lib/analytics/kpis/facebook/mediaViewer/comments';
import { impressionsMVConfig } from '@/lib/analytics/kpis/facebook/mediaViewer/impressions';
import { reachMVConfig } from '@/lib/analytics/kpis/facebook/mediaViewer/reach';
import { sharesMVConfig } from '@/lib/analytics/kpis/facebook/mediaViewer/shares';
import { clicksMVConfig } from '@/lib/analytics/kpis/facebook/mediaViewer/clicks';
import { engagementRateMVConfig } from '@/lib/analytics/kpis/facebook/mediaViewer/engagementRate';
import { engagementRateFollowersMVConfig } from '@/lib/analytics/kpis/facebook/mediaViewer/engagementRateFollowers';
import { engagementReachMVConfig } from '@/lib/analytics/kpis/facebook/mediaViewer/engagementReach';
import { reachRateMVConfig } from '@/lib/analytics/kpis/facebook/mediaViewer/reachRate';
import { reachRateFollowersMVConfig } from '@/lib/analytics/kpis/facebook/mediaViewer/reachRateFollowers';
import { postClicksDistributionConfig } from '@/lib/analytics/charts/facebook/mediaViewer/postClicksDistributionConfig';
import { reelsReachRateMVConfig } from '@/lib/analytics/kpis/facebook/mediaViewer/reelsReachRate';
import { reelsPlaysMVConfig } from '@/lib/analytics/kpis/facebook/mediaViewer/reelsPlays';
import { reelsReactionsMVConfig } from '@/lib/analytics/kpis/facebook/mediaViewer/reelsReactions';
import { reelsTotalTimeWatchedMVConfig } from '@/lib/analytics/kpis/facebook/mediaViewer/reelsTotalTimeWatched';
import { reelsAvgTimeWatchedMVConfig } from '@/lib/analytics/kpis/facebook/mediaViewer/reelsAvgTimeWatched';
import { reelsCommentsMVConfig } from '@/lib/analytics/kpis/facebook/mediaViewer/reelsComments';
import { reelsSharesMVConfig } from '@/lib/analytics/kpis/facebook/mediaViewer/reelsShares';
import { reelsReachMVConfig } from '@/lib/analytics/kpis/facebook/mediaViewer/reelsReach';

export const MediaViewerStatsFacebook = {
    [POST]: {
        [FB_POST_TYPES.TYPE_PHOTO]: [
            reactionsMVConfig,
            commentsMVConfig,
            impressionsMVConfig,
            reachMVConfig,
            sharesMVConfig,
            clicksMVConfig,
            engagementRateMVConfig,
            engagementReachMVConfig,
            reachRateMVConfig,
            engagementRateFollowersMVConfig,
            reachRateFollowersMVConfig,
            postClicksDistributionConfig
        ],
        [FB_POST_TYPES.TYPE_VIDEO]: [
            videoViewsCompleteMVConfig,
            videoViews3SecMVConfig,
            videoViews10SecMVConfig,
            videoViewsTotalTimeMVConfig,
            videoViewsAvgTimeWatchedMVConfig,
            reactionsMVConfig,
            commentsMVConfig,
            impressionsMVConfig,
            reachMVConfig,
            sharesMVConfig,
            clicksMVConfig,
            engagementRateMVConfig,
            engagementReachMVConfig,
            reachRateMVConfig,
            reachRateFollowersMVConfig,
            engagementRateFollowersMVConfig,
            postClicksDistributionConfig
        ],
        [FB_POST_TYPES.TYPE_STATUS]: [
            reactionsMVConfig,
            commentsMVConfig,
            impressionsMVConfig,
            reachMVConfig,
            sharesMVConfig,
            clicksMVConfig,
            engagementRateMVConfig,
            engagementReachMVConfig,
            reachRateMVConfig,
            engagementRateFollowersMVConfig,
            reachRateFollowersMVConfig,
            postClicksDistributionConfig
        ],
        [FB_POST_TYPES.TYPE_STORY]: [
            reactionsMVConfig,
            commentsMVConfig,
            impressionsMVConfig,
            reachMVConfig,
            sharesMVConfig,
            clicksMVConfig,
            engagementRateMVConfig,
            engagementReachMVConfig,
            reachRateMVConfig,
            reachRateFollowersMVConfig,
            engagementRateFollowersMVConfig,
            postClicksDistributionConfig
        ],
        [FB_POST_TYPES.TYPE_REEL]: [
            reelsPlaysMVConfig,
            reelsReactionsMVConfig,
            reelsTotalTimeWatchedMVConfig,
            reelsAvgTimeWatchedMVConfig,
            reelsCommentsMVConfig,
            reelsSharesMVConfig,
            engagementRateMVConfig,
            engagementRateFollowersMVConfig,
            reelsReachMVConfig,
            reelsReachRateMVConfig
        ]
    }
};
